<template>
  <v-container
    v-show="loaded"
    class="pt-16"
  >
    <v-card
      class="mx-auto"
      max-width="800"
      flat
      tile
    >
      <v-card-title>
        <h1
          class="fs-28 text-wrap"
          tabindex="0"
        >
          {{ $bct('Which child would you like to create an application for?') }}
        </h1>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-radio-group
              v-model="selectedChild"
              class="mb-5"
              hide-details
            >
              <RadioButton
                v-for="(child, index) in children"
                :key="child.id"
                :gap="radioButtonGap(index)"
                :subtitle="child.dob"
                :title="fullName(child)"
                :value="child"
                subtitle-icon="cake"
              />
            </v-radio-group>

            <v-btn
              @click="router.push({ name: 'ChildNew' })"
              color="primary"
              prepend-icon="add"
            >
              {{ $bct('Add another child') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :to="{ name: 'Dashboard' }"
          variant="text"
        >
          {{ $bct('Cancel') }}
        </v-btn>
        <v-spacer />
        <v-btn
          @click="router.push({ name: 'ChildApply', params: { childId: selectedChild.id } })"
          :disabled="!selectedChild"
          color="primary"
        >
          {{ $bct('Continue') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script setup>
import RadioButton from '@/shared/components/form/RadioButton.vue';
import { capitalize } from '@/plugins/filters';
import useApi from '@/shared/composables/useApi';
import { useRouter } from 'vue-router';

const { api } = useApi();
const router = useRouter();
const $bct = inject('translator');

const children = ref([]);
const group = ref(null);
const loaded = ref(false);
const selectedChild = ref(null);

function fullName(child) {
  let result = capitalize(child.first_name);
  if (child.middle_name) result += ` ${capitalize(child.middle_name)}`;
  result += ` ${capitalize(child.last_name)}`;

  return result;
}

async function load() {
  await loadGroup();
  await loadChildren();
  loaded.value = true;
}

async function loadChildren() {
  const resp = await api.parent.children.index();
  children.value = resp.data;
}

async function loadGroup() {
  const resp = await api.group.get();
  group.value = resp.data;
}

function radioButtonGap(index) {
  return index === 0 ? null : 5;
}

onMounted(async () => {
  await load();
});
</script>
